import { Component, SimpleChanges } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ModalController, AlertController, ActionSheetController, LoadingController, ToastController } from 'ionic-angular';
import { ClientCreatePage } from '../client-create/client-create';
import { Searchbar } from 'ionic-angular';
import { ViewChild  } from '@angular/core';


import { Items } from '../../providers/providers';


import { Client } from '../../models/client';
import { UserData } from '../../models/user';
import { UserAccount } from '../../models/account';
import { Grouping } from '../../models/groupings';


/**
 * Generated class for the ClientTabPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage({
  name: 'clients',
  segment: 'clients',
  priority: 'high'
})
@Component({
  selector: 'page-client-tab',
  templateUrl: 'client-tab.html',
})
export class ClientTabPage {

  currentItems: any[];
  schedules=[];
  responseData: any;
  administer: string;
  client: Client;
  index: any;
  userAccountData: UserAccount;
  text: string = 'noClientSelected';
  setGroup: boolean = false;
  @ViewChild('searchbar') searchbar:Searchbar;
  actionSheet: any;
  groupings: any[];
  groupings_array: any[];
  client_selected: any[] = [];
  userData: UserData;
  page_search: string = '';
  menu_search: string = '';
  show_result: boolean = false;
  displayList: Client[];
  inactive_placeholder: string = '';
  updatingStatus: boolean = false;
  sort: string = 'last_assessment';
  direction: string = 'DESC';
  page_count: number = 0;
  current_page: number = 1;
  group_id: string = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, 
  public modalCtrl: ModalController, public items: Items, public viewCtrl: ViewController, public alertCtrl: AlertController,
  public actionSheetCtrl: ActionSheetController, public loading: LoadingController, public toastCtrl: ToastController) {
    this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
}

  ionViewDidLoad() {
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()

    
    if (this.navParams.get('client')) {
        this.client = this.navParams.get('client');
        console.log(this.client)
        this.text = 'clientSelected'
    } else {
        this.text = 'noClientSelected'
    }

    this.getGroupings();
    
    this.getClientList(loading)
    
  }

  sortList(sort, direction) {
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()
    this.sort = sort
    this.direction = direction
    this.getClientList(loading)
  }

  addToSelectArray(client) {
    if (client.selected) {
      this.client_selected.push(client.id)
    } else {
      const index = this.client_selected.indexOf(client.id);
      if (index > -1) { // only splice array when item is found
        this.client_selected.splice(index, 1); // 2nd parameter means remove one item only
      }
    }
    console.log(this.client_selected)
  }

  onInput() {
    var menu_search = this.menu_search.trim()

    if (menu_search.length < 3) {
      this.displayList = [];
      this.show_result = false;
    } else {      
      this.items.getClientSmallList(this.menu_search).subscribe(res => {
        if (res) {
          this.displayList = res;
          this.show_result = true;
          return this.displayList;
          }
      }, err => {
        console.error('ERROR', err);
      });
    }    
  }

  selectClient(item) {
    this.navCtrl.push('clients', { clientId: item.id, client: item })

  }

  // ionViewDidEnter() {
  //   setTimeout(()=>{
  //       this.searchbar.setFocus();
  //   }, 2000);
  // }

  getGroupings() {
    this.groupings_array = [];
    this.items.getGroupings().subscribe(res => {
      if (res) {
        this.groupings = res;

        if (this.groupings.length > 0) {
          this.groupings.forEach(item => {
            let grp = {
              id: item.Grouping.id,
              name: item.Grouping.name,
              selected: false
            };

            this.groupings_array.push(grp);
          });
        }
      }
    },
      err => {
        console.log(err);
      });
  }

  getClientReportUrl (client_id) {
    var popup = window.open('', "_blank");
    this.items.getClientReportURL(client_id).subscribe(data => {
      if (data) {
        popup.location.href = data.url
      }
    },
      error => {
        console.log(error);
      }
    );
  }

  
  /**
   * Prompt the user to add a new item. This shows our ItemCreatePage in a
   * modal and then adds the new item to our data source if the user created one.
   */
  addClient() {
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()

    this.items.getAccountDetails().subscribe(res => {
      if (res) {
        this.userAccountData = res;
        if (parseInt(this.userAccountData.max_clients) - this.userAccountData.client_count < 4 ||
          this.userAccountData.client_count > parseInt(this.userAccountData.max_clients)) {
          this.presentAlert();
          loading.dismiss()
        }
        else {
          let addModal = this.modalCtrl.create(ClientCreatePage,{ userData: this.userAccountData }, { cssClass: "add-client-modal" });
          addModal.onDidDismiss(item => {
            if (item) {
              if (item.dismiss === 'done') {
                this.items.addClientStatic(item.form).subscribe(res => {
                  let client = res.json().data.client
                  console.log(client);
                  if (res) {
                    this.clientSelected(client, client.id)
                    this.getClientList(loading)
                  }
                }, err => {
                  loading.dismiss()
                  console.error('ERROR', err);
                });

              }
            }
          })
          loading.dismiss()
          addModal.present();
        }
      }
    }, err => {
        loading.dismiss()
        console.error('ERROR', err);
      });
  }

  editClient(client, index) {
    
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading', showBackdrop: false });
    loading.present()
      this.items.getClientNotesAndResponses(client.id).subscribe(res => {
        if (res) {
          client.assigned_users = res.assigned_users;
          client.assigned_groups = res.assigned_groups;
          client.groupings = res.groupings;
          client.practitioners = res.practitioners;
          
          this.userData = <UserData>JSON.parse(localStorage.getItem('userData'));
          let addModal = this.modalCtrl.create(ClientCreatePage, { client: client, userData: this.userData }, { cssClass: "add-client-modal" });
          addModal.onDidDismiss(item => {
            if (item) {
              if (item.dismiss === 'done') {
                let seq = this.items.editClient(item.form, client.id).share();
                seq
                  .map(res => res.json().data.client)
                  .subscribe(res => {
                    let toast = this.toastCtrl.create({
                      message: 'Client information updated',
                      duration: 3000,
                      position: 'top'
                    });
                    toast.present();
                  
                    this.getClientList(loading, client)
                  }, err => {
                    console.error('ERROR', err);
                    loading.dismiss()
                  });
              } else if (item.dismiss === 'inactive') {
                client.inactive = 1
                let seq = this.items.editClient(client, client.id).share();
                seq
                  .map(res => res.json().data.client)
                  .subscribe(res => {
                    let toast = this.toastCtrl.create({
                      message: 'Client information updated',
                      duration: 3000,
                      position: 'top'
                    });
                    toast.present();
                  
                    this.getClientList(loading)
                  }, err => {
                    console.error('ERROR', err);
                    loading.dismiss()
                  });
                //
              } else if (item.dismiss === 'delete') {
                  client.active = "0";
                  let seq = this.items.deleteClientStatic(client, client.id).share();
                  seq
                    .map(res => res.json().data.client)
                    .subscribe(res => {                      
                      this.getClientList(loading, null, false, this.current_page, true)
                    }, err => {
                      console.error('ERROR', err);
                      loading.dismiss()
                    });
              } else {
                loading.dismiss()
              }
            } else {
              loading.dismiss()
            }
          })
          addModal.present();
        }
      },
        err => {
          loading.dismiss()
          console.log(err);
        });
  }

  changeStatus(client, index) {
    this.updatingStatus = true
    let status = client.inactive == '1' ? '0' : '1';
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()
    
    this.items.clientChangeStatus(client.id, status).subscribe((resp) => {
      if (resp) {
        let toast = this.toastCtrl.create({
          message: 'Clients status updated',
          duration: 3000,
          position: 'top'
        });
        toast.present();

        this.currentItems[index].inactive = status
        loading.dismiss()
        this.updatingStatus = false
      } else {
        loading.dismiss()
        this.updatingStatus = false
      }      
      
    }, (err) => {
      let toast = this.toastCtrl.create({
        message: 'Failed to set client status',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      loading.dismiss()
      this.updatingStatus = false
    })
  }

  setGroupBulk() {
    var processed = 0
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()
    this.client_selected = []

    if (this.setGroup) {
      this.groupings_array.forEach((item, index, array) => {
        this.groupings_array[index].selected = false
      });

      if (this.currentItems.length > 0) {
        this.currentItems.forEach((item, index, array) => {
          processed++
          this.currentItems[index].selected = false
    
          if (processed == array.length) {
            this.setGroup = this.setGroup ? false : true
            loading.dismiss()
          }
        });
      }
    } else {
      this.setGroup = this.setGroup ? false : true
      loading.dismiss()
    }
  }

  setGrouping(grouping) {
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()

    if (this.client_selected.length == 0) {
      let toast = this.toastCtrl.create({
        message: 'You need to select at least one client',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      loading.dismiss()
      return;
    }

    this.items.setClientGrouping(this.client_selected, grouping.id, grouping.selected).subscribe((resp) => {
      if (resp) {
        let toast = this.toastCtrl.create({
          message: 'Clients grouping updated',
          duration: 3000,
          position: 'top'
        });
        toast.present();
      }
      
      this.getClientList(loading, null, true)
      
    }, (err) => {
      let toast = this.toastCtrl.create({
        message: 'Failed to set clients grouping',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      loading.dismiss()
    })
  }

  addNewClient(client: any){
    this.currentItems = this.items.getClients();
    this.client = this.currentItems[this.currentItems.length - 1];
    this.text = "clientSelected";
    console.log('addNewClient');
  }

  clientSelected(item,index){
    if (this.setGroup) {
      this.setGroupBulk()
    }
    this.client = item;
    this.text = "clientSelected";
    this.client.scheduleList = this.filterSchedules(item.id);
    this.index = index;
    
  }

  filterSchedules(clientId){
    return this.schedules.filter((item) => { 
      return item.client_id === clientId; })
  }

  filterClients() {
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()
    
    this.getClientList(loading)
  }

  resetClients() {
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()

    this.page_search = ''
    this.group_id = ''
    
    this.getClientList(loading)
  }

  getClientList(loading = null, client = null, select = false, page = 1, removed = false) {
    this.current_page = page;
    var querystring = '?page=' + page

    if (this.page_search != '') {
      querystring += '&keyword=' + this.page_search
    }
    
    if (this.sort != '') {
      querystring += '&sort=' + this.sort
    }
    
    if (this.direction != '') {
      querystring += '&direction=' + this.direction
    }
    
    if (this.group_id != '') {
      querystring += '&group_id=' + this.group_id
    }

    this.items.getClientListPaged(querystring).subscribe(res => {
      if (res) {
        this.currentItems = res.Clients;
        this.page_count = res.pages;
        console.log(this.currentItems)

        if (select) {
          this.currentItems.forEach((item) => {
            if (this.client_selected.indexOf(item.id) !== -1) {
              item.selected = true
            }
          });
        }
      }

      if (loading) {
        loading.dismiss()
      }
      
      if (client) {
        this.client = client
        this.text = "clientSelected";
      }

      if (removed) {
        this.text = "noClientSelected"
      }
    }, err => {
      console.error('ERROR', err);
      if (loading) {
        loading.dismiss()
      }
    });
  }

  goToPage (page) {
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()
    
    this.getClientList(loading, null, false, page)
  }

  filterGroup(groupId) {
    this.group_id = groupId
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()
    
    this.getClientList(loading)
  }  

  presentToast(msg) {
    let toast = this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }  

  addGrouping() {
    let prompt = this.alertCtrl.create({
      title: 'Client Group',
      message: "Create new client group",
      inputs: [
        {
          name: 'groupName',
          placeholder: 'Enter group name'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {

          }
        },
        {
          text: 'OK',
          handler: data => {
            if (data.groupName.trim == '') {
              this.presentToast("Please insert the new client group name")
            } else {
              let grouping = new Grouping(data.groupName);
              this.items.addGrouping(grouping).subscribe((resp) => {
                this.presentToast("Group successfully created");
                this.getGroupings();
              }, (err) => {
                this.presentToast("Error creating group");
              })
            }
          }
        }
      ]
    });
    prompt.present();
  }

  calculateAge(birthday) {
    if (birthday) {

      var timeDiff = Math.abs(Date.now() - Date.parse(birthday));
      //Used Math.floor instead of Math.ceil
      //so 26 years and 140 days would be considered as 26, not 27.
      return Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    }
  }

  updateClient(client){
    if(client.active == "0"){
      let toast = this.toastCtrl.create({
        message: 'Client deleted',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      this.deleteClient(client);
    }else{
      let toast = this.toastCtrl.create({
        message: 'Client information updated',
        duration: 3000,
        position: 'top'
      });
      toast.present();
      this.getClientList(null, client)
    }
    if(client.deleteSchedule == "0"){
      this.items.getSchedules().subscribe(res => {
        if (res) {
          this.schedules = res;
          //this.client.scheduleList = this.filterSchedules(this.currentItems[index].id);
        }
      },
        err => {
          console.log(err);
        });
    }
    
  }

  goBackToFront(client){
    this.text = "noClientSelected"
    
  }

  deleteClient(client){
    let loading = this.loading.create({ spinner: 'circles', content: "Loading...", cssClass: 'activity-detail-loading' });
    loading.present()
    
    this.getClientList(loading, null, false, 1, true)
    
  }

  goToClientsPage(){
    this.navCtrl.push('clients');
  }
  
  goToHomePage(){
    this.navCtrl.push('home');
  }
  
  goToAssessmentsPage(){
    this.navCtrl.push('assessments');
  }

  goToInsightPage() {
    this.navCtrl.push('redirect-insights');
  }
  
  goToAccountsPage(){
    this.navCtrl.push('account');
  }

  presentAlert() {
    let alert = this.alertCtrl.create({
      title: parseInt(this.userAccountData.max_clients) - this.userAccountData.client_count + ' clients left on your limit',
      subTitle: 'You are currently on the ' + this.userAccountData.chargebee_plan + ' Plan, which allows you to add ' + this.userAccountData.max_clients + ' clients. You have added ' + this.userAccountData.client_count + ' clients so far. ' + 'Would you like to upgrade your limit?',
      buttons: [
        {
          text: 'Later',
          handler: data => {
            if (this.userAccountData.client_count <= parseInt(this.userAccountData.max_clients)) {
              let addModal = this.modalCtrl.create(ClientCreatePage,{ userData: this.userAccountData }, { cssClass: "add-client-modal" });
              addModal.onDidDismiss(item => {
                if (item) {
                  if (item.dismiss === 'done') {
                    // let client = this.items.addClient(item.form);
                    this.items.addClient(item.form).subscribe(res => {
                      if (res) {
                        this.currentItems = this.items.getClients();
                        this.client = this.currentItems[this.currentItems.length - 1];//select the last added client.
                        this.text="clientSelected"
                      }
                    }, err => {
                      console.error('ERROR', err);
                    });
                  }
                }
              })
              addModal.present();
            }
          }
        },
        {
          text: 'Upgrade',
          handler: data => { 
            this.navCtrl.push('account');
          }
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/client-tab/client-tab.ts